import React from 'react';
import {
  Box,
  Typography,
  Slider,
  Paper,
  Chip
} from '@mui/material';
import { LocationOn, Tune } from '@mui/icons-material';

const StationSearchSettingsSection = ({ 
  showStationSettings, 
  toggleStationSettings, 
  stationRadius, 
  setStationRadius 
}) => {
  const handleRadiusChange = (event, newValue) => {
    setStationRadius(newValue);
  };

  const getRadiusColor = (radius) => {
    if (radius <= 20) return '#4caf50';
    if (radius <= 50) return '#ff9800';
    return '#f44336';
  };

  const getRadiusDescription = (radius) => {
    if (radius <= 10) return 'Very Close';
    if (radius <= 25) return 'Close';
    if (radius <= 50) return 'Moderate';
    if (radius <= 100) return 'Wide';
    return 'Very Wide';
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: '#f8f9fa',
        border: '1px solid #e0e0e0'
      }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1, 
          mb: 2,
          cursor: 'pointer'
        }}
        onClick={toggleStationSettings}
      >
        <LocationOn sx={{ color: '#4caf50', fontSize: 20 }} />
        <Typography variant="subtitle2" fontWeight={600} sx={{ flex: 1 }}>
          Station Search Radius
        </Typography>
        <Chip
          label={`${stationRadius}km`}
          size="small"
          sx={{
            backgroundColor: `${getRadiusColor(stationRadius)}20`,
            color: getRadiusColor(stationRadius),
            fontSize: '0.75rem',
            fontWeight: 600
          }}
        />
        <Tune sx={{ color: '#666', fontSize: 18 }} />
      </Box>

      {showStationSettings && (
        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Search radius: {stationRadius}km
            </Typography>
            <Chip
              label={getRadiusDescription(stationRadius)}
              size="small"
              variant="outlined"
              sx={{
                ml: 'auto',
                borderColor: getRadiusColor(stationRadius),
                color: getRadiusColor(stationRadius),
                fontSize: '0.7rem',
                height: 20
              }}
            />
          </Box>

          <Slider
            value={stationRadius}
            onChange={handleRadiusChange}
            min={5}
            max={200}
            step={5}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => `${value}km`}
            sx={{
              color: getRadiusColor(stationRadius),
              '& .MuiSlider-thumb': {
                backgroundColor: getRadiusColor(stationRadius),
                '&:hover, &.Mui-focusVisible': {
                  boxShadow: `0 0 0 8px ${getRadiusColor(stationRadius)}30`
                }
              },
              '& .MuiSlider-track': {
                backgroundColor: getRadiusColor(stationRadius)
              },
              '& .MuiSlider-rail': {
                backgroundColor: '#e0e0e0'
              },
              '& .MuiSlider-valueLabel': {
                backgroundColor: getRadiusColor(stationRadius),
                fontSize: '0.75rem'
              }
            }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <Typography variant="caption" color="text.secondary">
              5km (Nearby)
            </Typography>
            <Typography variant="caption" color="text.secondary">
              200km (Extended)
            </Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default StationSearchSettingsSection;